export default __webpack_public_path__ + "static/media/aixin.1dba745d.png";